import React from "react";
import styles from "./ImageSlider.module.css";

const ImageSlider = () => {
  const images = [
    "https://cdn.web.imagine.art/imagine-frontend/assets/images/RowImageSlider4.webp",
    "https://cdn.web.imagine.art/imagine-frontend/assets/images/RowImageSlider2.webp",
    "https://cdn.web.imagine.art/imagine-frontend/assets/images/RowImageSlider4.webp",
    "https://cdn.web.imagine.art/imagine-frontend/assets/images/RowImageSlider2.webp",
    "https://cdn.web.imagine.art/imagine-frontend/assets/images/RowImageSlider4.webp",
    "https://cdn.web.imagine.art/imagine-frontend/assets/images/RowImageSlider2.webp",
    "https://cdn.web.imagine.art/imagine-frontend/assets/images/RowImageSlider4.webp",
  ];

  return (
    <div className={styles.slider}>
      <div className={styles.slideTrack}>
        {images.map((image, index) => (
          <div className={styles.slide} key={index}>
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              title={`Slide ${index + 1}`}
              width="auto"
              height="auto"
              loading="lazy"
              decoding="async"
              aria-describedby="image-caption"
            />
          </div>
        ))}
        {images.map((image, index) => (
          <div className={styles.slide} key={index + images.length}>
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              title={`Slide ${index + 1}`}
              width="auto"
              height="auto"
              loading="lazy"
              decoding="async"
              aria-describedby="image-caption"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
